import posthog from "posthog-js";

export const captureToofiAnalytics = (event: string, properties?: Record<string, unknown>) => {
  try {
    posthog.capture(event, properties);
  } catch {
    // best effort only
  }
};
